import CustomLabel from "../../frameworks/components/CustomLabel";

const NISTFunctionToShortened = {
  Identify: "ID",
  Protect: "PR",
  Detect: "DE",
  Respond: "RS",
  Recover: "RC",
  Govern: "GV",
};

const NISTLabel = ({ nistFunction, size = "small" }) => {
  return (
    <CustomLabel
      text={NISTFunctionToShortened[nistFunction]}
      colorFamily="NIST"
      severity={nistFunction}
      labelType="filled"
      size={size}
      width="40px"
    />
  );
};

export default NISTLabel;
